import { atom } from "jotai";

import { SignatureFlowStep } from "../types/signature-flow-step.enum";
import type { IDocumentSignaturePositionWithPageIndex } from "../../../legacy/services/BuildSignaturePosition/DocumentSignaturePosition.interface";

export interface ISignatureDocumentFlowState {
  step: SignatureFlowStep;
  documentId?: number;
  fileUrl?: string;
  signatures: IDocumentSignaturePositionWithPageIndex[];
}

export const DEFAULT_SIGNATURE_DOCUMENT_FLOW_STATE: ISignatureDocumentFlowState = {
  step: SignatureFlowStep.View,
  signatures: [],
};

export const signatureDocumentFlowAtom = atom<ISignatureDocumentFlowState>(DEFAULT_SIGNATURE_DOCUMENT_FLOW_STATE);
